
<div class="body-wrapper">
  <app-nav-menu></app-nav-menu>
  <div class="root-container">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>
</div>
<app-footer></app-footer>